import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import "leaflet.markercluster"

export default class extends Controller {
  static values = {
    locations: Array
  }

  connect() {
    this.initializeMap()
  }

  initializeMap() {
    if (this.map) {
      this.map.remove()
    }

    this.map = L.map(this.element).setView([52.3676, 4.9041], 7)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 18,
    }).addTo(this.map)

    this.markerClusterGroup = L.markerClusterGroup({
      iconCreateFunction: function(cluster) {
        return L.divIcon({
          html: `<div class="marker-cluster">${cluster.getChildCount()}</div>`,
          className: ''
        })
      }
    })

    this.addMarkers()
    this.map.addLayer(this.markerClusterGroup)
  }

  locationsValueChanged() {
    if (this.map) {
      this.initializeMap()
    }
  }

  addMarkers() {
    if (!this.locationsValue.length) return

    const bounds = L.latLngBounds()

    this.locationsValue.forEach(location => {
      const marker = L.marker([location.latitude, location.longitude])
        .bindPopup(`<strong>${location.name}</strong><br>${location.address}`)
      
      this.markerClusterGroup.addLayer(marker)
      bounds.extend([location.latitude, location.longitude])
    })

    if (!bounds.isValid()) {
      this.map.setView([52.3676, 4.9041], 7)
    } else {
      this.map.fitBounds(bounds)
    }
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
      this.markerClusterGroup = null
    }
  }
}
